import * as Routes from '../constants/routes';

import Intro from '../calculators/mortgage/containers/intro';
import StepOne from '../calculators/mortgage/containers/step-one';
import StepTwo from '../calculators/mortgage/containers/step-two';
import StepThree from '../calculators/mortgage/containers/step-three';
import StepFour from '../calculators/mortgage/containers/step-four';
import StepFive from '../calculators/mortgage/containers/step-five';
import StepSix from '../calculators/mortgage/containers/step-six';
import StepSeven from '../calculators/mortgage/containers/step-seven';
import StepEight from '../calculators/mortgage/containers/step-eight';
import StepNine from '../calculators/mortgage/containers/step-nine';
import Summary from '../calculators/mortgage/containers/summary';
import Contact from '../calculators/mortgage/containers/contact';
import ThankYou from '../calculators/mortgage/containers/thank-you';

export const name = 'Mortgage Affordability Calculator';

export const inNavigation = true;

export const redirectFromSteps = true;

export const routes = [
    {
        path: Routes.HOME,
        component: Intro,
        pagination: false,
        progressBar: false
    },
    {
        path: Routes.STEPONE,
        component: StepOne,
        pagination: {
            next: {
                type: 'submit',
                label: '<strong>Next: </strong> <span>Your Monthly Debt</span>'
            }
        }
    },
    {
        path: Routes.STEPTWO,
        component: StepTwo,
        pagination: {
            next: {
                type: 'submit',
                label: '<strong>Next: </strong> <span>Credit Score</span>'
            }
        }
    },
    {
        path: Routes.STEPTHREE,
        component: StepThree,
        pagination: {
            next: {
                type: 'submit',
                label: '<strong>Next: </strong> <span>Down Payment</span>'
            }
        },
        tips: {
            title: "What's a credit score?",
            content: "Your credit score is a 3-digit number (300\u2013900) that helps lenders see your financial picture. If your score is 650 or below, pre-approval can be tougher - but our Libro Coaches can help you build a plan and keep your home goals on track.",
            button: {
                link: 'https://www.libro.ca/learn/advice/money-management/credit-scores-credit-reports/',
                label: 'Learn More',
                target: '_blank'
            }
        }
    },
    {
        path: Routes.STEPFOUR,
        component: StepFour,
        pagination: {
            next: {
                type: 'submit',
                label: '<strong>Next: </strong> <span>Amortization Rate</span>'
            }
        },
        tips: {
            title: 'Did you know?',
            content: 'In Canada, with a down payment of less than 20%, you are required to purchase mortgage default insurance through CMHC or Sagen insurance. This insurance is calculated as a percentage and can be added to your mortgage at Libro, however, you will need to pay PST on the insurance in your closing costs.',
            button: {
                link: 'https://www.cmhc-schl.gc.ca/en/finance-and-investing/mortgage-loan-insurance/mortgage-loan-insurance-homeownership-programs/cmhc-mortgage-loan-insurance-cost',
                label: 'Learn More',
                target: '_blank'
            }
        }
    },
    {
        path: Routes.STEPFIVE,
        component: StepFive,
        pagination: {
            next: {
                type: 'submit',
                label: '<strong>Next: </strong> <span>Your Payment Frequency</span>'
            }
        }
    },
    {
        path: Routes.STEPSIX,
        component: StepSix,
        pagination: {
            next: {
                type: 'submit',
                label: '<strong>Next: </strong> <span>Your Mortgage Term</span>'
            }
        },
        tips: {
            title: 'Did you know?',
            content: 'Weekly and bi-weekly payments allow you to make additional payments throughout the year. Over the life of your mortgage, this can take months or even years off of your mortgage.'
        }
    },
    {
        path: Routes.STEPSEVEN,
        component: StepSeven,
        pagination: {
            next: {
                type: 'submit',
                label: '<strong>Next: </strong> <span>Your Mortgage Rate</span>'
            }
        }
    },
    {
        path: Routes.STEPEIGHT,
        component: StepEight,
        pagination: {
            next: {
                type: 'submit',
                label: '<strong>Next: </strong> <span>Your Closing Costs</span>'
            }
        },
        tips: {
            title: 'Did you know?',
            content: "All Canadian mortgages must pass a \u201Cstress test\u201D to make sure you can afford your payments if interest rates rise at renewal. While your payment is based on today\u2019s rate, you qualify using a higher benchmark rate\u2014the Bank of Canada\u2019s 5-year conventional mortgage rate. Your Libro Coach can guide you through it.",
            additionalContent: "To see the qualifying rate, click the link below and scroll to the \u201CInterest Rates\u201D section to find the 5-year conventional mortgage rate.",
            button: {
                link: 'https://www.bankofcanada.ca/rates/daily-digest/',
                label: 'Bank of Canada Rate',
                target: '_blank'
            }
        }
    },
    {
        path: Routes.STEPNINE,
        component: StepNine,
        pagination: {
            next: {
                type: 'submit',
                label: '<strong>Next: </strong> <span>Summary</span>'
            }
        }
    },
    {
        path: Routes.SUMMARY,
        component: Summary,
        pagination: false,
        progressBar: false
    },
    {
        path: Routes.CONTACT,
        component: Contact,
        pagination: false,
        progressBar: false
    },
    {
        path: Routes.THANKYOU,
        component: ThankYou,
        pagination: false,
        progressBar: false
    }
];
